import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";
import { getHotArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function HotBoardSection() {
  const hot = getHotArticles(6);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="REALTIME RANK"
              title="今日热度榜"
              description="按站内讨论量实时排序，想知道现在大家在吃哪个瓜，看这里就够了。"
            />
            <ol className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 px-5 py-2">
              {hot.map((article, index) => (
                <li key={article.id}>
                  <ArticleCard article={article} variant="compact" rank={index + 1} />
                </li>
              ))}
            </ol>
            <Link
              to="/category/jingtian"
              className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer"
            >
              查看更多惊天大瓜
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="CATEGORIES"
              title="按类型吃瓜"
              description="五个栏目，对应五种不同的吃瓜需求，挑一个直接进。"
            />
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {categories.slice(0, 4).map((category) => (
                <Link
                  key={category.slug}
                  to={`/category/${category.slug}`}
                  className="group relative flex h-40 flex-col justify-end overflow-hidden rounded-lg bg-foreground-950 p-5 cursor-pointer"
                >
                  <img
                    src={category.image}
                    alt={category.imageAlt}
                    className="absolute inset-0 h-full w-full object-cover object-top opacity-70 transition-all duration-500 group-hover:scale-105 group-hover:opacity-90"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/50 to-transparent" />
                  <div className="relative z-10">
                    <h3 className="font-heading text-lg font-bold text-background-50">
                      {category.name}
                    </h3>
                    <p className="mt-1 line-clamp-2 text-xs text-background-200">
                      {category.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            <Link
              to={`/category/${categories[4]?.slug ?? "chaoji"}`}
              className="group mt-4 flex items-center justify-between gap-4 rounded-lg border border-secondary-200 bg-secondary-100 px-5 py-4 transition-colors hover:border-secondary-400 cursor-pointer"
            >
              <div>
                <h3 className="font-heading text-base font-bold text-secondary-900">
                  {categories[4]?.name}
                </h3>
                <p className="mt-0.5 text-xs text-secondary-800">
                  {categories[4]?.description}
                </p>
              </div>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50 transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}